const config = {
    APIURL: 'https://aedmap.io'
}
module.exports = config
